import shopifyGenericDefaults from '../shopify-generic/config.js';

const searchBoxWithGarageSelector = '#cm-search-box-with-garage';

const widgets = shopifyGenericDefaults.Widgets.filter(
  (widget) => !['StockFacet', 'Garage', 'SearchBox'].includes(widget.name),
).map((widget) => {
  if (widget.name === 'Facets' || widget.name === 'FilterChips') {
    return {
      ...widget,
      ignoreFields: [...(widget.ignoreFields || []), 'stock'],
    };
  }

  if (widget.name === 'FacetDialog') {
    return {
      ...widget,
      initCollapsed: false,
    };
  }

  return widget;
});

export default {
  ...shopifyGenericDefaults,
  includes: ['shopify-generic'],
  facets: {
    ...shopifyGenericDefaults.facets,
    toggleFacet: [{ fields: ['stock'], term: 'In-stock-Only' }],
  },
  Widgets: [
    ...widgets,
    {
      name: 'StockFacet',
      type: 'FacetPanel',
      fields: ['stock'],
    },
    {
      name: 'Garage',
      location: {
        firstChildOf: searchBoxWithGarageSelector,
        class: 'cm_garage__searchBox',
      },
      template: 'fitmentSearch/garage',
      isAutoVehicleSelectionDisabled: false,
    },
    {
      name: 'SearchBox',
      location: {
        lastChildOf: searchBoxWithGarageSelector,
        class: 'cm_search-box-root__searchBox',
      },
      template: 'SearchBox',
      onDropdownItemsReceived: shopifyGenericDefaults.Widgets.find((w) => w.name === 'SearchBox')
        .onDropdownItemsReceived,
    },
  ],
};
